export const Roles = {

    // ID
    ADMIN_ID: 1,
    TM_ID: 5,
    SH_ID: 7,
    NH_ID: 8,
    BH_ID: 9,
    TCO_ID: 11,

    // Full name
    TM_NAME: 'territory_manager',
    SH_NAME: 'state_head',
    NH_NAME: 'national_head',
    BH_NAME: 'business_head',
    TCO_NAME: 'tco',
    CNF_ROLE:'cnf'
    
}